import CareerOnboardView from './CareerOnboardView'
export default CareerOnboardView
